import React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { Button } from '@resiliatech/birdsong'
import { IntakeFlowStep, Priority } from '../../constants'
import { ChipsContainer, StyledChip } from './TopPriorities.styled'
import { ActionContainer, Container } from '../../IntakeFlow.styled'

const TOPICS: Priority[] = [
  'Board Management',
  'Compliance',
  'Data & Impact',
  'Diversity, Equity, & Inclusion',
  'Accessibility',
  'Event Management',
  'Finance',
  'Formation',
  'Fundraising',
  'Grants',
  'Marketing & Communications',
  'People Operations',
  'Program Management',
  'Storytelling',
  'Strategic Planning',
  'Technology Solutions',
  'Volunteer Management',
]

type Props = {
  onNextStep: (nextStep: IntakeFlowStep) => void
  onBackStep: () => void
  selectedPriorities: Priority[]
  onUpdatePriorities: (priorities: Priority[]) => void
}

export const TopPriorities = ({
  onNextStep,
  onBackStep,
  selectedPriorities,
  onUpdatePriorities,
}: Props) => {
  const priorities = Array.isArray(selectedPriorities) ? selectedPriorities : []

  const handleSelect = (topic: Priority) => {
    if (priorities.includes(topic)) {
      onUpdatePriorities(priorities.filter((t) => t !== topic))
    } else if (priorities.length < 3) {
      onUpdatePriorities([...priorities, topic])
    }
  }

  return (
    <Container>
      <ChipsContainer>
        {TOPICS.map((topic) => (
          <StyledChip
            key={topic}
            label={topic}
            onClick={() => handleSelect(topic)}
            variant={priorities.includes(topic) ? 'filled' : 'outlined'}
            deleteIcon={priorities.includes(topic) ? <CloseIcon /> : undefined}
            onDelete={
              priorities.includes(topic) ? () => handleSelect(topic) : undefined
            }
          />
        ))}
      </ChipsContainer>

      <ActionContainer>
        <Button variant='text' onClick={onBackStep}>
          Back
        </Button>
        <Button
          variant='primary'
          onClick={() => onNextStep(IntakeFlowStep.CONFIDENCE_RATING)}
          isDisabled={priorities.length !== 3}
          label='Next'
        />
      </ActionContainer>
    </Container>
  )
}
